import { v4 } from 'uuid';
import BaseModel from './BaseModel';

/** One wizard step in a form layout (single level). */
class FormLayoutStep extends BaseModel {
    constructor(properties) {
        super(properties || {});

        if (!this.id) {
            this.id = v4();
        }

        if (this.label === undefined || typeof this.label !== 'object') {
            this.label = {};
        }

        if (this.breadcrumbLabel === undefined && this.breadcrumb_label != null) {
            this.breadcrumbLabel = this.breadcrumb_label;
        }
        delete this.breadcrumb_label;
        if (!this.breadcrumbLabel || typeof this.breadcrumbLabel !== 'object') {
            this.breadcrumbLabel = {};
        }

        if (this.nextLabel === undefined && this.next_label != null) {
            this.nextLabel = this.next_label;
        }
        delete this.next_label;
        if (!this.nextLabel || typeof this.nextLabel !== 'object') {
            this.nextLabel = {};
        }

        if (this.nextIcon === undefined && this.next_icon != null) {
            this.nextIcon = this.next_icon;
        }
        delete this.next_icon;
        if (this.nextIcon === undefined || this.nextIcon === null) {
            this.nextIcon = 'arrow-right';
        }

        if (this.position === undefined || this.position === null) {
            this.position = 0;
        }

        if (this.transition === undefined || this.transition === null) {
            this.transition = 'fade';
        }
        if (this.transition === 'inherit') {
            this.transition = 'fade';
        }
    }

    static getDefaultOptions() {
        return {
            id: v4(),
            name: 'step',
            label: {},
            breadcrumbLabel: {},
            nextLabel: {},
            nextIcon: 'arrow-right',
            position: 0,
            transition: 'fade',
        };
    }

    toPlainObject = () => JSON.parse(JSON.stringify(this));
}

export default FormLayoutStep;
